import { createRoot } from 'react-dom/client'

import App from '@/App/components/App'

import '@arcotech-services/iris-tokens/theme-core.css'
import '@arcotech-services/iris-react/css/index.css'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element not found')
}

const root = createRoot(container)

const basename = '/gestora-avaliacoes'

if (!window.location.pathname.startsWith(basename)) {
  const suffix =
    window.location.pathname === '/' ? '' : window.location.pathname
  window.location.replace(`${basename}${suffix}`)
}

root.render(<App basename={basename} />)
